export class Doctors{
    Id:number;
    Name:any;
    Contact:any
    DistrictId:number;
    DFId:any
}